
























import RuleScript from '@/domain/scripts/entity/rule-script.entity';
import RuleScriptService from '@/domain/scripts/service/rule-script.service';
import { VbSnackbarService } from '@/shared/snackbar/snackbar.service';
import {
  Vue, Component, Prop, Watch,
} from 'vue-property-decorator';
import RuleDatatable from './datatable/rule-datatable.component.vue'
import NewScriptEdition from './new-script/new-script.component.vue';

@Component({ components: { RuleDatatable, NewScriptEdition } })

export default class ScriptConfiguration extends Vue {
  @Prop() businessUnitId!: string;

  showScriptEdition: boolean = false;

  ruleToEdit: RuleScript = RuleScript.of({});

  editModeValue: boolean = false;

  valid: boolean = false;

  previewModeValue: boolean = false;

  startNewScript() {
    this.ruleToEdit = RuleScript.of({
      script: '// descomente o resultado final ideal para você: \n'
        + '// context.finish(RESULTADO)\n'
        + '// context.finishWithScale(RESULTADO,PRECISAO)',
    });
    this.showScriptEdition = true;
  }

  preview(ruleId: string) {
    this.getRule(ruleId);
    this.previewModeValue = true;
  }

  editRule(ruleId: string) {
    this.getRule(ruleId);
    this.editModeValue = true;
  }

  handleRuleCreated(rule: RuleScript) {
    this.ruleToEdit = rule;
    this.editModeValue = true;
  }

  resetRuleEditionAndPreview() {
    this.ruleToEdit = RuleScript.of({});
    this.showScriptEdition = false;
    this.editModeValue = false;
    this.previewModeValue = false;
  }

  getRule(ruleId: string) {
    RuleScriptService.getRule(this.businessUnitId, ruleId)
      .then((response: any) => {
        this.ruleToEdit = RuleScript.of(response);
        this.showScriptEdition = true;
      })
      .catch((err) => VbSnackbarService.handleHttpError(err));
  }
}

